import React from "react";
import { IChartTopSalesClient } from "src/shared/models/IDashboards.models";
import { fCurrencyND } from '../../helpers/generalFunctions';
import BootstrapTable from "react-bootstrap-table-next";
import { Type } from "react-bootstrap-table2-editor";
import { NoDataChart } from "./NoDataChart";

interface FormProps {
  details: IChartTopSalesClient[];
  tableTitle: string;
  titleChartNoData: string;
  typeIcon?: boolean;
}


export const TableForDashboard = React.memo(({details, tableTitle, titleChartNoData, typeIcon = true }: FormProps) => {
  const columns = [
    {
      dataField: "name",
      text: "Cliente",
      sort: false,
      style: {
        paddingLeft: 22
      },
      headerStyle: {
        paddingLeft: 22,
        fontSize: 12,
        fontWeight: 500
      },
    },
    {
      dataField: "transactionsQty",
      text: "Transacciones",
      align: "center",
      sort: false,
      style: {},
      headerStyle: {
        fontSize: 12,
        fontWeight: 500
      },
    },   
    {
      dataField: "totalSales",
      text: "Ventas Totales",
      sort: false,
      editable: false,
      headerStyle: {
        fontSize: 12,
        fontWeight: 500
      },
      // align: "right",
      formatter: (
        cellContent: any,
        item: any,
        index: number,
        extraData: number
      ) => (
        <>
          {`L. ${fCurrencyND(cellContent)}`}
        </>
      ),
    },
    {
      dataField: "lastPurchase",
      text: "Última compra",
      sort: false,
      editable: false,
      align: "center",
      headerStyle: {
        fontSize: 12,
        fontWeight: 500
      },
      type: 'date',
      formatter: (cell) => {
        let dateObj = cell;
        if (typeof cell !== 'object') {
          dateObj = new Date(cell);
        }
        return `${('0' + dateObj.getDate()).slice(-2)}/${('0' + (dateObj.getMonth() + 1)).slice(-2)}/${dateObj.getFullYear()}`;
      },
      editor: {
        type: Type.DATE
      }
    }, 
    {
      dataField: "storeName",
      text: "Sucursal",
      sort: false,
      style: {},
      headerStyle: {
        fontSize: 12,
        fontWeight: 500
      },
    },   
  ];

  return (
    <React.Fragment>
      <h5 className="font-size-12 mb-3 ps-4" style={{fontFamily:"Open Sans,sans-serif", marginTop:"20px", color:"#000"}}><strong>{tableTitle}</strong></h5>
      <div className="w-100">
        <BootstrapTable
          key={"customerId"}
          // defaultSorted={defaultSorted}
          classes={
            "table align-middle table-nowrap table-condensed table-hover"
          }
          headerClasses="custom-header-horizontal-borders custom-header-blue-background" // Apply custom classes
          rowStyle={{ fontSize: 10 }}
          bordered={false}
          striped={false}
          keyField="customerId"
          data={details || []}
          noDataIndication={() => (
            <NoDataChart
              titleChart={tableTitle}
              titleChartNoData={titleChartNoData}
              typeIcon={typeIcon}
              showTitle={false}
            />
          )}
          columns={columns}
          condensed={true}
        />
        </div>
    </React.Fragment>
  );
});
